// Implements: F-UIX-018, F-IDN-027
/**
 * `/backoffice/teams/:teamId`: one team of Equipos (mockup v3 P3). The container is keyed by the
 * team's id (checklist 14), so moving from one team to another never shows the previous members.
 */

import type { ReactElement } from "react";
import { useParams } from "react-router";

import { ByOrganization } from "../../modules/organization/containers/ByOrganization";
import { TeamDetailContainer } from "../../modules/organization/containers/TeamDetailContainer";
import { useSession } from "../../shared/api/session";
import { TEAM_ACTIONS } from "./TeamsPage";

export function TeamDetailPage(): ReactElement | null {
  const { teamId = "" } = useParams();
  const { state } = useSession();
  // `RequireSession` renders this page only for a session; nothing to show otherwise.
  if (state.status !== "authenticated") return null;
  const { user, scopes } = state.view;

  return (
    <ByOrganization key={user.id} scopes={scopes} actions={TEAM_ACTIONS}>
      {(target) => (
        <TeamDetailContainer key={teamId} organizationId={target.organizationId} teamId={teamId} scopes={scopes} />
      )}
    </ByOrganization>
  );
}
